import { useMemo, useCallback } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';

import {
  selectPsrPreferencesArr,
  setPsrPreferences
} from 'state/psr/psr-slice';
import { canonicalPsr } from '../utils';
import { NsCheckboxInput } from 'components/common/ns-checkbox-input/NsCheckboxInput';

import type { PsrType } from '../psr-types';
type PsrItemProps = {
  psrItem: PsrType;
  parentCode?: string | null;
};
export const testId = 'psrItemTestId';

export const PsrItem = ({ psrItem, parentCode = '' }: PsrItemProps) => {
  const dispatch = useDispatch();
  const psrPreferences = useSelector(selectPsrPreferencesArr, shallowEqual);

  const { code, type } = psrItem;
  const name = `${parentCode || ''}-${code}`;
  const isChecked = !!psrPreferences.find((psrPref) => {
    const cPsr = canonicalPsr({
      ...psrItem,
      parentCode
    });
    return psrPref.code === cPsr.code && psrPref.subCode === cPsr.subCode;
  });

  const handleChange = useCallback(
    (e) => {
      const { value } = e.target;
      const checked = !!value;
      const psrPref = canonicalPsr({
        ...psrItem,
        parentCode
      });

      dispatch(setPsrPreferences({ psrItem: psrPref, type, checked }));
    },
    [dispatch, parentCode, type, psrItem]
  );

  return useMemo(
    () => (
      <NsCheckboxInput
        name={name}
        testId={testId}
        value={isChecked ? name : ''}
        onChange={handleChange}
        options={[{ label: psrItem.displayName, value: name }]}
      />
    ),
    [psrItem, name, isChecked, handleChange]
  );
};
